import { AfterViewInit, Component, ElementRef, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-banca-en-linea',
  templateUrl: './banca-en-linea.component.html',
  styleUrls: ['./banca-en-linea.component.scss']
})
export class BancaEnLineaComponent implements OnInit, AfterViewInit {

  constructor(private elementRef: ElementRef) { }

  ngAfterViewInit(): void {
    this.elementRef.nativeElement.ownerDocument.body.style.backgroundImage  = "url('assets/img/banca-en-linea/background.jpg')";
  }

  ngOnInit() {
    $(".c-body").removeClass("background-banca");
  }
  
  readLocalStorageValue(key) {
    return localStorage.getItem(key);
  }

  setLocalStorageValue(key){
    localStorage.setItem('idiomaEspañol',key);
  }

}
